<app-sales-credit-number [creditNumber]="request?.number" [data]="request"></app-sales-credit-number>

<app-sales-phone-enrollment-library
  *ngIf="isEnrollmentEngine; else manualEnrollmentFlow"
  [enrollmentContext]="enrollmentLibraryContext"
  (enrollmentCompletedEvent)="onEnrollmentLibraryCompleted($event)">
</app-sales-phone-enrollment-library>

<ng-template #manualEnrollmentFlow>
  <!--INICIO DEL ENROLLAMIENTO DATACULTR-->
  <app-sales-phone-enrollment-manual-init-enrollment-datacultr (step)="onStep($event)" *ngIf="['init-enrollment-datacultr'].includes(step)">
  </app-sales-phone-enrollment-manual-init-enrollment-datacultr>

  <!--INICIO DEL ENROLLAMIENTO KNOX-->
  <app-sales-phone-enrollment-manual-init-enrollment-knox (step)="onStep($event)" [phoneEnrollmentData]="phoneEnrollmentData" *ngIf="['init-enrollment-knox'].includes(step)">
  </app-sales-phone-enrollment-manual-init-enrollment-knox>

  <!--INICIO DEL ENROLLAMIENTO NUOVO-->
  <app-sales-phone-enrollment-manual-init-enrollment-nuovo (step)="onStep($event)" [phoneEnrollmentData]="phoneEnrollmentData" *ngIf="['init-enrollment-nuovo'].includes(step)">
  </app-sales-phone-enrollment-manual-init-enrollment-nuovo>

  <!--INICIO DEL ENROLLAMIENTO TRUSTONIC-->
  <app-sales-phone-enrollment-manual-init-enrollment-trustonic (step)="onStep($event)" *ngIf="['init-enrollment-trustonic'].includes(step)">
  </app-sales-phone-enrollment-manual-init-enrollment-trustonic>

  <!--PREGUINTA SOBRE EL PROCESO DATACULTR-->
  <app-sales-phone-enrollment-manual-questions-process-datacultr (step)="onStep($event)" [phoneEnrollmentData]="phoneEnrollmentData" [request]="request" *ngIf="['questions-process-datacultr'].includes(step)">
  </app-sales-phone-enrollment-manual-questions-process-datacultr>

  <!--PREGUINTA SOBRE EL PROCESO KNOX-->
  <app-sales-phone-enrollment-manual-questions-process (step)="onStep($event)" *ngIf="['questions-process'].includes(step)">
  </app-sales-phone-enrollment-manual-questions-process>

  <!--PREGUINTA SOBRE EL PROCESO NUOVO-->
  <app-sales-phone-enrollment-manual-questions-process-nuovo [phoneEnrollmentData]="phoneEnrollmentData" (step)="onStep($event)" *ngIf="['questions-process-nuovo'].includes(step)">
  </app-sales-phone-enrollment-manual-questions-process-nuovo>

  <!--PREGUINTA SOBRE EL PROCESO TRUSTONIC-->
  <app-sales-phone-enrollment-manual-questions-process-trustonic (step)="onStep($event)" *ngIf="['questions-process-trustonic'].includes(step)">
  </app-sales-phone-enrollment-manual-questions-process-trustonic>

  <!--EN PROGRESO-->
  <app-sales-phone-enrollment-manual-in-progress (nextStepEvent)="onNextStep()" (gotoStepEvent)="onGotoStep($event)" (onError)="onError($event)" (step)="onStep($event)" *ngIf="['in-progress'].includes(step)"></app-sales-phone-enrollment-manual-in-progress>

  <!--MENSAJE FALLIDO-->
  <app-sales-phone-enrollment-manual-fail-message *ngIf="['fail-message'].includes(step)"></app-sales-phone-enrollment-manual-fail-message>

  <!--MENSAJE FALLIDO CON REINTENTO-->
  <app-sales-phone-enrollment-manual-retry-message [message]="message" (step)="onStep($event)" (gotoStepEvent)="onGotoStep($event)" *ngIf="['retry-message'].includes(step)"></app-sales-phone-enrollment-manual-retry-message>
</ng-template>
